 import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Source_Search_Fields: {[id:string]: ISearchProviderField } = {
    SOURCE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SOURCE_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    BUSINESS_CONTACT:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Business Contact', columnResourceName: 'colBusinessContact', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    TECHNICAL_CONTACT:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tech Contact', columnResourceName: 'colTechContact', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_SOURCE_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Source', columnResourceName: 'colWB_Source', alignment:HorizAlignment.Center}, domainOptions: {}},
    MDSET:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colMDSet', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 20}},
    SOURCE_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Type', columnResourceName: 'colSourceType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 10}}
}

var SourceSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_SOURCE_ID',
        id_ui: 'SOURCE_ID',
        name:  'SOURCE_NAME'},


    searchProviderFields: vUI_Source_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Source_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var SourceSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "SourceSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'SOURCE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'SOURCE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'SOURCE_ID','SOURCE_NAME','BUSINESS_CONTACT','TECHNICAL_CONTACT','MDSET','SOURCE_TYPE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SourceSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var SourceSearch: ISearch = {
    searchName: "Find Source",
    renderOptions: { ui5ResourceId: "SourceSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SourceSearchProfileByName]
}
 PAEnvironment.registerBusinessObjectSearch("SourceBO", "Source", SourceSearch, "Source Search")

export {SourceSearch}